// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2aK48","rightPanel":"Footer_rightPanel__2CTOf","leftPanel":"Footer_leftPanel__KhOBq"};